import TCountryCodes from './TCountryCodes';
import validationByTenant from './validationByCountryCode';
import isValid from './isValid';

/**
 *
 * cocNumber: Chamber of Commerce Business Number.
 * Each country has different validation for this business number
 */
type TCocNumberValidation = {
  isValid(cocNumber: string): boolean;
  maxLength: number | undefined;
};

export default (countryCode: TCountryCodes): TCocNumberValidation => {
  const validation = validationByTenant[countryCode];

  return {
    isValid: (cocNumber: string) => isValid(cocNumber, validation),
    maxLength: validation && validation.maxLength,
  };
};
